"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OurBrands = exports.loadTheme = void 0;
const overridesUpgradeMixer_1 = require("./themeParts/overridesUpgradeMixer");
const fonts_1 = require("./themeParts/fonts");
const colors_1 = require("./themeParts/colors");
Object.defineProperty(exports, "OurBrands", { enumerable: true, get: function () { return colors_1.OurBrands; } });
const buildColorsByBrand_1 = require("./themeParts/buildColorsByBrand");
const shadows_1 = require("./themeParts/shadows");
const styles_1 = require("@mui/material/styles");
const loadTheme = (brandStyles = colors_1.OurBrands.SigmaAldrich, makeNotoPrimaryFont = false) => {
    const generatedColorData = (0, buildColorsByBrand_1.buildColorsByBrand)(brandStyles);
    const fontFamilySet = makeNotoPrimaryFont ? fonts_1.notoFontFamily : fonts_1.latoFontFamily;
    const Colors = generatedColorData.colors;
    const AccentColors = generatedColorData.accentColors;
    const fontBases = (0, fonts_1.buildBaseFontStyles)(makeNotoPrimaryFont, brandStyles);
    const muiThemeConfig = {
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960, // Changed from default to match UX designs
                lg: 1280, // Changed from default to match UX designs
                xl: 1536,
            },
        },
        palette: {
            action: {
                disabledBackground: Colors.Grey500,
                focus: Colors.PrimaryMain,
            },
            background: {
                default: Colors.White,
                grey: Colors.BackgroundGray,
                highlight: Colors.Highlight,
                blue: Colors.BackgroundBlue,
            },
            badge: {
                highContrastGreen: Colors.HighContrastGreen,
            },
            brand: {
                dark: Colors.BrandDark,
                light: Colors.BrandLight,
                main: Colors.BrandMain,
            },
            divider: Colors.Divider,
            error: {
                main: Colors.ErrorMain,
                light: Colors.ErrorLight,
            },
            grey: {
                '50': Colors.Grey50,
                '100': Colors.Grey100,
                '200': Colors.Grey200,
                '300': Colors.Grey300,
                '400': Colors.Grey400,
                '500': Colors.Grey500,
                '600': Colors.Grey600,
                '700': Colors.Grey700,
                '800': Colors.Grey800,
                '900': Colors.Grey900,
            },
            info: {
                main: Colors.PrimaryMain,
            },
            primary: {
                light: Colors.PrimaryLight,
                main: Colors.PrimaryMain,
                dark: Colors.PrimaryDark,
            },
            rich: {
                purple: AccentColors.RichPurple,
                blue: AccentColors.RichBlue,
                green: AccentColors.RichGreen,
                red: AccentColors.RichRed,
            },
            secondary: {
                light: Colors.SecondaryLight,
                main: Colors.SecondaryMain,
                dark: Colors.SecondaryDark,
            },
            sensitive: {
                pink: AccentColors.SensitivePink,
                blue: AccentColors.SensitiveBlue,
                green: AccentColors.SensitiveGreen,
                yellow: AccentColors.SensitiveYellow,
            },
            success: {
                main: Colors.SuccessMain,
                dark: Colors.SuccessDark,
                light: Colors.SuccessLight,
            },
            text: {
                primary: Colors.TextPrimary,
            },
            vibrant: {
                magenta: AccentColors.VibrantMagenta,
                cyan: AccentColors.VibrantCyan,
                green: AccentColors.VibrantGreen,
                yellow: AccentColors.VibrantYellow,
            },
            warning: {
                main: Colors.WarningMain,
                dark: Colors.WarningDark,
                light: Colors.WarningLight,
            },
            orange: Colors.Orange,
            promoGreen: AccentColors.PromoGreen,
            tonalOffset: 0.1,
        },
        typography: {
            fontFamily: fontFamilySet,
            fontWeightRegular: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Regular
                : fonts_1.FontWeights.Regular,
            fontWeightMedium: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.SemiBold
                : fonts_1.FontWeights.Bold,
            fontWeightBold: makeNotoPrimaryFont
                ? fonts_1.NotoFontWeights.Bold
                : fonts_1.FontWeights.Black,
            h1: fontBases.h1,
            h2: fontBases.h2,
            h3: fontBases.h3,
            h4: fontBases.h4,
            body1: fontBases.body1,
            body2: fontBases.body2,
            caption: fontBases.caption,
        },
        shape: {
            borderRadius: 5,
        },
        spacing: 4,
        shadows: shadows_1.shadowsArray,
    };
    const overridesAndComponents = (0, overridesUpgradeMixer_1.buildMuiOverridesAndComponents)(brandStyles, makeNotoPrimaryFont);
    const muiTheme = muiThemeConfig;
    muiTheme.components = overridesAndComponents;
    return (0, styles_1.createTheme)(muiTheme);
};
exports.loadTheme = loadTheme;
//# sourceMappingURL=index.js.map